'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('@active/react-ui/shared/utils');

var _dataAccess = require('@active/react-ui/shared/data-access');

var da = _interopRequireWildcard(_dataAccess);

var _injectL10n = require('@active/react-ui/shared/injectL10n');

var _injectL10n2 = _interopRequireDefault(_injectL10n);

require('./NativeDropDown.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NativeDropDown = function (_Component) {
  (0, _inherits3.default)(NativeDropDown, _Component);

  function NativeDropDown(props) {
    (0, _classCallCheck3.default)(this, NativeDropDown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NativeDropDown.__proto__ || (0, _getPrototypeOf2.default)(NativeDropDown)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        value = _this$props.value,
        defaultValue = _this$props.defaultValue;

    var val = value || defaultValue;

    _this.state = {
      value: val
    };
    return _this;
  }

  return NativeDropDown;
}(_react.Component);

NativeDropDown.defaultProps = {
  size: 'm',
  theme: 'flat'
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSelectChange = function (e) {
    var value = e.target.value;


    _this2.setState({ value: value }, function () {
      if (_this2.props.onChange) {
        _this2.props.onChange({ value: value });
      }
    });
  };

  this.componentWillReceiveProps = function (nextProps) {
    var newState = {};
    if (nextProps.value !== _this2.props.value) {
      newState.value = nextProps.value;
    } else if (nextProps.defaultValue !== _this2.props.defaultValue) {
      newState.value = _this2.state.value === undefined ? nextProps.defaultValue : _this2.state.value;
    }

    if ((0, _keys2.default)(newState).length > 0) {
      _this2.setState(newState);
    }
  };

  this.render = function () {
    var _props = _this2.props,
        className = _props.className,
        disabled = _props.disabled,
        data = _props.data,
        preIcon = _props.preIcon,
        _props$placeholder = _props.placeholder,
        placeholder = _props$placeholder === undefined ? '' + _this2.props.l10n.formatMessage('react-aaui.common.dropdown.notice.select') : _props$placeholder,
        size = _props.size,
        theme = _props.theme,
        isMoreButton = _props.isMoreButton,
        style = _props.style,
        rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'disabled', 'data', 'preIcon', 'placeholder', 'size', 'theme', 'isMoreButton', 'style']);
    var value = _this2.state.value;

    var validProps = (0, _utils.filterValidProps)(rest);
    var defaultClassNames = {
      dropdown: true,
      'dropdown--native': true,
      'dropdown--disabled': disabled
    };
    if (theme) {
      defaultClassNames['dropdown--' + theme] = theme;
    }
    if (size) {
      defaultClassNames['dropdown--' + size] = size;
    }
    var classes = (0, _classnames2.default)(defaultClassNames, className);
    var selectClasses = (0, _classnames2.default)({
      dropdown__button: true,
      dropdown__select: true,
      disabled: disabled
    });

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({
        className: classes,
        style: style
      }, validProps),
      preIcon && _react2.default.createElement('i', { className: 'dropdown__prefix-icon ' + preIcon }),
      _react2.default.createElement(
        'select',
        {
          className: selectClasses,
          onChange: _this2.onSelectChange,
          value: value,
          disabled: disabled },
        !!(placeholder && !value) && _react2.default.createElement(
          'option',
          { value: 'prompt' },
          ' ',
          placeholder,
          ' '
        ),
        data.map(function (item) {
          return _react2.default.createElement(
            'option',
            { value: item.value, key: item.value },
            ' ',
            da.get(item, 'text'),
            ' '
          );
        })
      ),
      isMoreButton ? _react2.default.createElement('span', { className: 'icon-caret-down' }) : _react2.default.createElement('span', { className: 'icon-chevron-down' })
    );
  };
};

exports.default = (0, _injectL10n2.default)()(NativeDropDown);